<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <form @submit.prevent="save">
                    <div class="card">
                        <div class="card-header">
                            <i class="fas fa-satellite-dish"></i> Integradora
                        </div>
                        <div class="card-block form form-horizontal">
                            <div class="form-group row">
                                <div
                                    class="col-md-4"
                                    :class="{ 'has-danger': $v.model.nome.$error }"
                                >
                                    <label>Nome*</label>
                                    <input
                                        type="text"
                                        maxlength="50"
                                        class="form-control"
                                        v-model="model.nome"
                                    />
                                </div>
                                <div
                                    class="col-md-2"
                                    :class="{ 'has-danger': $v.model.codigo.$error }"
                                >
                                    <label>Código*</label>
                                    <input
                                        type="text"
                                        maxlength="20"
                                        class="form-control"
                                        v-model="model.codigo"
                                    />
                                </div>

                                <div class="col-md-3 align-self-center">
                                    <label>Ativo</label>
                                    <br />
                                    <input-toggle v-model="model.ativo" :value="model.ativo"></input-toggle>
                                </div>
                            </div>

                            <div class="form-group row">
                                <div class="col-md-4">
                                    <label>Token</label>
                                    <input
                                        type="text"
                                        maxlength="150"
                                        class="form-control"
                                        v-model="model.token"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="card-footer text-right">
                            <router-link
                                :to="{ name: 'list-integrator' }"
                                class="btn btn-link"
                            >Cancelar</router-link>
                            <button type="submit" class="btn btn-primary">Salvar</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Facade from "../../facade/facade";
const facade = new Facade();
import {
    required,
    minLength,
    maxLength,
    withParams,
    email
} from "vuelidate/lib/validators";
import {
    isNotUndefinedOrNullOrEmptyOrZero,
    isUndefinedOrNullOrEmpty
} from "@/services/string";
export default {
    data() {
        return {
            model: {
                id: null,
                nome: "",
                ativo: 0,
                codigo: "",
                token: ''
            }
        };
    },
    validations() {
        let vm = this;

        return {
            model: {
                nome: {
                    required,
                    minLength: minLength(2)
                },
                codigo: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(20)
                }
            }
        };
    },
    methods: {
        async save() {
            let vm = this;
            if (this.$v.model.$invalid) {
                this.$v.model.$touch();
                this.$notify.warning(
                    "Atenção!",
                    "Verifique se todos os campos estão preenchidos corretamente."
                );
                return;
            }

            this.$loading.show(true);

            try {
                if (vm.model.id) {
                    await facade.updateIntegrator(vm.model, vm.model.id);
                } else {
                    await facade.createIntegrator(vm.model);
                }

                this.$router.push({ name: "list-integrator" });

                this.$loading.show(false);
            } catch (e) {
                e.forEach(item => {
                    this.$notify.error(item.field, item.message);
                });
                this.$loading.show(false);
            }
        },
        throwError(e) {
            this.$notify.error("Erro!", e);
        },
        setData(model) {
            let vm = this;

            if (model !== undefined && model !== null) {
                vm.model = model;
            }
        }
    },
    async beforeRouteEnter(to, from, next) {
        let integrator = null;

        if (to.params.id) {
            integrator = (await facade.getIntegrator(to.params.id)).data.data;
        }

        next(vm => vm.setData(integrator));
    }
};
</script>



// WEBPACK FOOTER //
// Form.vue?27e9a8ae